import React from 'react'
import {
  fetchVisionCommunitySummary,
  type VisionCommunitySummaryMap,
} from '../services/visionCommunityService'

export function useVisionCommunitySummary(visionIds: number[], enabled: boolean) {
  const [map, setMap] = React.useState<VisionCommunitySummaryMap | null>(null)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const ids = React.useMemo(
    () =>
      Array.from(
        new Set(
          (visionIds || [])
            .map((id) => Number(id))
            .filter((id) => Number.isFinite(id)),
        ),
      ),
    [visionIds],
  )

  React.useEffect(() => {
    if (!enabled || ids.length === 0) {
      setMap(null)
      setLoading(false)
      setError(null)
      return
    }

    let active = true
    setLoading(true)
    setError(null)

    fetchVisionCommunitySummary(ids)
      .then((data) => {
        if (!active) return
        setMap(data)
      })
      .catch((e: any) => {
        if (!active) return
        setMap(null)
        setError(e?.message || 'Falha ao carregar comunidade das visoes')
      })
      .finally(() => {
        if (!active) return
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [enabled, ids])

  return { map, loading, error }
}
